import { cn } from '@/shared/lib/cn'
import { getDisplayInitials } from '@/shared/lib/displayInitials'

export type UserAvatarSize = 'sidebar' | 'profile'

const SIZE_CLASS: Record<UserAvatarSize, string> = {
  sidebar: 'h-8 w-8 rounded-xl text-xs',
  profile: 'h-14 w-14 rounded-2xl text-sm',
}

interface UserAvatarProps {
  name: string
  avatarUrl?: string | null
  size?: UserAvatarSize
  className?: string
}

export const UserAvatar = ({
  name,
  avatarUrl,
  size = 'profile',
  className,
}: UserAvatarProps) => {
  const sizeClass = SIZE_CLASS[size]

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        aria-hidden
        className={cn(sizeClass, 'shrink-0 object-cover', className)}
      />
    )
  }

  return (
    <div
      className={cn(
        sizeClass,
        'flex shrink-0 items-center justify-center bg-[var(--color-mint-soft)] font-semibold text-[var(--color-teal-ink)]',
        className,
      )}
      aria-hidden
    >
      {getDisplayInitials(name)}
    </div>
  )
}